export enum ComposantAttenduReponseEnum {
  oui = 'Oui',
  non = 'Non',
  neSaisPas = 'Ne sais pas',
  inaccessible = 'Inaccessible'
}
